import styled from "styled-components"

import { MEDIA_QUERIES } from "@constants"

export const PostHeroWebinarHostsDIV = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
  text-align: center;
  margin-bottom: var(--spacing--M);

  ${MEDIA_QUERIES.L} {
    position: absolute;
    top: calc(var(--spacing--M) * 2);
    left: 0;
    width: 114px;
    margin-right: -91px;
    margin-left: 15px;
  }

  .Avatar {
    margin-bottom: var(--spacing--XS);
  }

  > div {
    padding: 0 15px;
    max-width: 144px;

    ${MEDIA_QUERIES.L} {
      margin-bottom: var(--spacing--S);
      padding: 0;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    p {
      margin: 0;
    }
  }
`
